module.exports = __webpack_public_path__ + "static/media/accompany_map_important.f791eb0b.svg";